/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description constants
 */

/**
 * DEFAULT_TIME_ZONE
 * @type {string}
 * @exports
 */
const DEFAULT_TIME_ZONE = 'CST6CDT';

/**
 * MINUTES_IN_HOUR
 */
const MINUTES_IN_HOUR = 60;

/**
 * SHORT_DATE_FORMAT
 */
const SHORT_DATE_FORMAT = 'MMM D, YYYY';

const YEAR_MONTH_DATE_FORMAT = 'YYYY-MM-DD';

const YEAR_MONTH_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

const YEAR_MONTH_DATE_TIME_FORMAT_WITH_TIMEZONE = 'YYYY-MM-DDTHH:mm:ssZ';

const MONTH_DATE_YEAR_TIME_FORMAT = 'MM-DD-YYYY h:mm:ss A';

const MONTH_DATE_YEAR_TIME_WITH_MERIDIEM_FORMAT = 'MMM DD, YYYY, h:mma';

/**
 * MINIMUM_DESKTOP_VIEWPORT_WIDTH
 * for mobile load blocking
 */
const MINIMUM_DESKTOP_VIEWPORT_WIDTH = 640;

/**
 * MONTH_DATE_YEAR_
 */
const MONTH_DATE_YEAR_SLASH_FORMAT = 'MM/DD/YYYY';

/**
 * MONTH_YEAR_FORMAT
 */
const MONTH_YEAR_FORMAT = 'MMM D, YYYY';

/**
 * empty value for details in cards
 */
const EMPTY_VALUE = '-';

/**
 * empty value for date range
 */
const EMPTY_VALUE_FOR_DATE_RANGE = '--/--/----';

/**
 * PHONE_REGEX 10 digit
 */
const PHONE_REGEX = /^[0-9]{10}$/;

/**
 * form fields group style
 */
// TODO - remove this
const FORM_FIELDS_GROUP_STYLE = { maxWidth: 800, marginTop: 24 };

/**
 * form layout style
 */
// TODO - remove this
const FORM_LAYOUT_STYLE = { width: '80%', margin: 'auto' };

/**
 * Form field patterns
 */
const FIELD_VALIDATORS = {
	patientFirstName: {
		pattern: new RegExp("^[a-zA-Z0-9\\s!&,()+'-./;?=#\\]]{1,35}$"),
		message: 'Please enter a valid first name',
	},
	patientMiddleName: {
		pattern: new RegExp("^[a-zA-Z0-9\\s!&,()+'-./;?=#\\]]{1,25}$"),
		message: 'Please enter a valid middle name',
	},
	patientLastName: {
		pattern: new RegExp("^[a-zA-Z0-9\\s!&,()+'-./;?=#\\]]{1,60}$"),
		message: 'Please enter a valid last name',
	},
	patientSuffix: {
		pattern: new RegExp("^[a-zA-Z0-9\\s!&,()+'-./;?=#\\]]{1,10}$"),
		message: 'Please enter a valid suffix',
	},
	stateCode: {
		pattern: new RegExp('^[A-Z]{2,2}$'),
		message: 'Please enter a valid state code',
	},
	ssn: {
		pattern: new RegExp('^\\d{9}$'),
		message: 'Please enter a valid Social Security Number',
	},
	memberId: {
		pattern: new RegExp('^[A-Za-z0-9-]{2,80}$'),
		message: 'Please enter a valid Member ID',
	},
	commonIdentifier: {
		pattern: new RegExp('^[^~:^]{1,50}$'),
		message: 'Please enter a valid Common Identifier',
	},
	npi: {
		pattern: new RegExp('^\\d{10}$'),
		message: 'Please enter a valid NPI Number',
	},
	organizationName: {
		pattern: new RegExp('^[0-9a-zA-Z \\-_]+$'),
		message: 'Please enter a valid Organization Name',
	},
	providerName: {
		pattern: new RegExp('^[0-9a-zA-Z \\-_]+$'),
		message: 'Please enter a valid Provider Name',
	},
	locationName: {
		pattern: new RegExp('^[0-9a-zA-Z \\-_]+$'),
		message: 'Please enter a valid Location Name',
	},
	tin: {
		pattern: new RegExp('^\\d{9}$'),
		message: 'Please enter a 9-digit TIN/EIN',
	},
};

// animation
const DEFAULT_SLIDE_IN_ANIMATION = 'slideIn 0.3s ease-in-out';

const DEFAULT_SLIDE_OUT_ANIMATION = 'slideOut 0.3s ease-in-out';

/**
 * posthog groups
 * Don't change the mapping as it will break the posthog groups or create new groups
 */
const POSTHOG_GROUPS = {
	tenant: 'tenant',
};

/**
 * PLATFORMS for app
 */
const PLATFORMS: Record<string, UniversalSearch.Platform> = {
	mac: 'mac',
	other: 'other',
};

/**
 * HOT_KEYS for app
 */
const HOT_KEYS = {
	universalSearch: {
		[PLATFORMS.mac]: {
			key: 'meta+k',
			icon: '⌘ K',
		},
		[PLATFORMS.other]: {
			key: 'ctrl+k',
			icon: 'Ctrl K',
		},
	},
};

export {
	DEFAULT_TIME_ZONE,
	SHORT_DATE_FORMAT,
	YEAR_MONTH_DATE_FORMAT,
	MONTH_DATE_YEAR_SLASH_FORMAT,
	EMPTY_VALUE,
	EMPTY_VALUE_FOR_DATE_RANGE,
	YEAR_MONTH_DATE_TIME_FORMAT,
	MONTH_DATE_YEAR_TIME_FORMAT,
	YEAR_MONTH_DATE_TIME_FORMAT_WITH_TIMEZONE,
	PHONE_REGEX,
	DEFAULT_SLIDE_IN_ANIMATION,
	DEFAULT_SLIDE_OUT_ANIMATION,
	POSTHOG_GROUPS,
	FIELD_VALIDATORS,
	FORM_FIELDS_GROUP_STYLE,
	MINIMUM_DESKTOP_VIEWPORT_WIDTH,
	PLATFORMS,
	HOT_KEYS,
	MINUTES_IN_HOUR,
	MONTH_YEAR_FORMAT,
	FORM_LAYOUT_STYLE,
	MONTH_DATE_YEAR_TIME_WITH_MERIDIEM_FORMAT,
};
